import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";

import {
  ThemeProvider,
  LoadingBar,
  defaultTheme,
  StoreProvider,
  ControllerProvider,
} from "@searchspring/snap-preact-components";
import { Header } from "../Header/Header";
import { Results, NoResults, ResultsWrapper } from "../Results/Results";
@observer
export class Content extends Component {
  render() {
    const store = this.props.controller.store;

    let leftColumnLayout = window.Resources.searchspring.toolbar.leftColumnLayout;
    if (leftColumnLayout == 'false') {
      leftColumnLayout = "";
    }

    return (
      <ControllerProvider controller={this.props.controller}>
        <ThemeProvider theme={defaultTheme}>
          <StoreProvider store={store}>
            <div>
              <LoadingBar active={store.loading} />

              <Header />
                <ResultsWrapper>
                  {store.pagination.totalResults ? (
                    <Results leftColumnLayout={leftColumnLayout} />
                  ) : (
                    (store.pagination.totalResults === 0) && <NoResults leftColumnLayout={leftColumnLayout} />
                  )}
                </ResultsWrapper>
            </div>
          </StoreProvider>
        </ThemeProvider>
      </ControllerProvider>
    );
  }
}
